
<template>
  <div class="flex flex-wrap md:flex-nowrap gap-1 font-sans items-start">

    <!-- LEFT SIDE -->
    <div class="w-full md:w-2/3">
      <div class="flex flex-col space-y-3 bg-white rounded-lg shadow-lg p-4">

        <!-- search -->
        <input
          v-model="searchTerm"
          type="text"
          placeholder="Search..."
          class="w-60 px-2 py-1 border border-gray-300 rounded-md text-sm shadow-sm
                 focus:border-[#add8e6] focus:outline-none focus:ring-1 focus:ring-[#add8e6]"
        />

        <!-- departments -->
  

<!-- Added outline-none to remove the focus border -->
<div class="flex w-full overflow-x-auto outline-none" style="scrollbar-width:none; -ms-overflow-style:none;" tabindex="-1">
  <div
    v-for="(dept,index) in departments"
    :key="dept.id"
    @click="selectDept(dept)"
    :class="[
      'flex-1 min-w-fit px-4 text-xs whitespace-nowrap cursor-pointer h-9 flex items-center justify-center flex-shrink-0',
      /* Keep existing border logic */
      index === 0 ? 'rounded-l-sm' : '',
      index === departments.length - 1 ? 'rounded-r-sm' : '',
      selectedDept && selectedDept.id === dept.id
        ? 'bg-green-700 text-white border-none shadow-none text-bold'
        : 'text-gray-800 hover:bg-gray-100 border border-gray-300'
    ]"
  >
    {{ dept.name }}
  </div>
</div>




        <!-- sub departments -->
        <div 
          v-if="selectedDept && selectedDept.subDepartments && selectedDept.subDepartments.length" 
          class="flex overflow-x-auto" 
          style="scrollbar-width:none; -ms-overflow-style:none;" 
          tabindex="-1"
        >
          <div
            v-for="(sub,index) in selectedDept.subDepartments"
            :key="sub.id"
            @click="selectSub(sub)"
            :class="[
              'px-2 text-xs whitespace-nowrap cursor-pointer h-8 min-h-8 flex items-center justify-center flex-shrink-0',
              index === 0 ? 'rounded-l-sm' : '',
              index === selectedDept.subDepartments.length - 1 ? 'rounded-r-sm' : '',
              selectedSub && selectedSub.id === sub.id
                ? 'bg-blue-500 text-white border-none text-bold'
                : 'text-[#0d4169] font-bold hover:bg-gray-100 border border-gray-300'
            ]"
            :style="{ minWidth: '60px' }"
          >
            {{ sub.name }}
          </div>
        </div>

        <!-- menus grid -->
        <div class="">
          <div class="grid gap-1 grid-cols-2 md:grid-cols-3 lg:grid-cols-4 mt-3">
          <div
  v-for="menu in filteredMenus"
  :key="menu.id || menu._id || menu.code"
  @click="((menu.isAvailable ?? menu.is_available ?? 1) === 1) ? addToBill(menu) : null"
  class="cursor-pointer border rounded-lg p-2 flex flex-col justify-between bg-white shadow-lg hover:shadow-xl transition-all duration-150 active:bg-[#1a5a8a] active:text-white"
  :class="{ 
    'cursor-not-allowed grayscale-[0.5]': (menu.isAvailable ?? menu.is_available ?? 1) === 0 
  }"
>
  <div>
    <h4 
      class="text-base font-semibold transition-colors duration-150"
      :class="{ 'text-red-600': (menu.isAvailable ?? menu.is_available ?? 1) === 0 }"
    >
      {{ menu.name }}
    </h4>

    <p 
      class="text-sm text-gray-600 mt-1 transition-colors duration-150"
      :class="{ 'text-red-400': (menu.isAvailable ?? menu.is_available ?? 1) === 0 }"
    >
      {{ ((Number(menu.totalPrice ?? menu.total_price) || 0).toFixed(2)) }}
    </p>
  </div>
</div>

            <div
              v-if="filteredMenus.length === 0"
              class="col-span-full text-center py-10 font-bold"
              style="color: #0d4169;"
            >
             <div class="text-2xl">Wellcome Back,</div>
             <div class="text-lg opacity-80 mt-2">Have you a nice day!</div>
             <div 
               class="text-sm mt-4 font-medium"
               :class="departments.length === 0 ? 'text-red-600' : 'opacity-60'"
             >
               {{ departments.length === 0 ? 'No department to select' : 'Select department to continue' }}
             </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- RIGHT SIDE -->
    <div class="w-full md:w-1/3  ">
      <div class="flex flex-col bg-white rounded-lg shadow-lg border-l border-gray-200">

        <!-- action buttons above bill -->
       <div class="flex items-center justify-between flex-nowrap p-4 pt-1 pr-1 pl-2 pb-2 border-b border-gray-100 overflow-hidden bg-gray-50/50">
  
  <!-- LEFT SIDE -->
  <div class="flex items-center space-x-1 overflow-hidden">
    
    <!-- <div class="relative inline-flex items-start mr-3">
      <button 
        @click="() => { clearBillAreaOnly(); showTransferModal = true; }"
        class="px-2 py-1 text-sm border border-gray-300 rounded-sm hover:bg-gray-100 bg-white shadow-sm font-semibold text-gray-700"
      >
        Transfer
      </button>

      <span 
        v-if="transferBadgeCount > 0"
        class="absolute top-1.5 left-2 -translate-y-1/2 -translate-x-1/2 bg-red-600 text-white text-[9px] w-4 h-3 px-1 rounded-full flex items-center justify-center font-bold shadow z-50"
      >
        {{ transferBadgeCount }}
      </span>
    </div> -->

    <button 
      @click="() => { clearBillAreaOnly(); fetchOrders(); }" 
      :class="['px-2 py-1 text-[12px] border rounded-sm flex-shrink-0 font-semibold shadow-sm transition-all', viewMode === 'orders' ? 'bg-blue-600 text-white border-blue-600' : 'bg-white border-gray-300 text-gray-700 hover:bg-gray-100']"
    >
      My orders
    </button>
  </div>

  <!-- RIGHT SIDE -->
  <span 
    v-if="selectedOrderDate" 
    class="text-[10px] font-black text-[#0d4169] bg-white px-1 py-1 whitespace-nowrap"
  >
    {{ selectedOrderDate }}
  </span>

</div>

        <hr>
     <!-- Changed items-center to items-stretch and added flex to children -->
        <!-- NEW HEADER LAYOUT -->
      

<div class="bg-[#0d4169] pb-2">

  <!-- TOP GRID: LEFT + RIGHT -->
  <div class="grid grid-cols-[minmax(108px,_auto)_1fr] py-2 border-b border-gray-100 px-2">
    
    <!-- LEFT -->
    <div class="text-left flex flex-col space-y-1 h-full pr-2 ">
      <div class="flex flex-col">
        <div v-if="tableError && !isDelivery" class="text-[10px] font-bold text-red-500 mt-0.5 animate-bounce">
          Select Table Number
        </div>

        <div class="text-white text-[15px] font-bold tracking-tight whitespace-nowrap">
          Table &nbsp;
          <span class="font-bold">
            {{ tableNumber || '---' }}
          </span>

          <button 
            v-if="false" 
            @click="tableNumber = ''" 
            :disabled="!!currentEditingOrderId"
            :class="currentEditingOrderId ? 'opacity-50 cursor-not-allowed' : 'hover:text-red-700'"
            class="text-red-500 text-sm ml-1"
          >
            ×
          </button>
        </div>
      </div>

      <hr>

      <div class="flex flex-col text-white">
        <div class="text-[12px] font-bold capitalize leading-tight">Staff Name</div>
        <div class="text-[15px] font-bold capitalize tracking-tight whitespace-nowrap">
          {{ selectedWaiter.split(" ")[0] }}
        </div>
      </div>
    </div>

    <!-- RIGHT -->
    <div class="flex flex-col space-y-1 pl-2 border-l border-gray-100 w-full">
      <!-- Row 1 -->
      <div class="flex w-full space-x-1">
        <button 
          v-for="n in [1, 2, 3, 4, 5]" 
          :key="n"
          :disabled="true"
          class="flex-1 h-8 flex items-center justify-center border border-gray-200 text-[16px] font-black bg-gray-50 text-gray-700 rounded shadow-sm opacity-50 cursor-not-allowed"
        >
          {{ n }}
        </button>
      </div>

      <!-- Row 2 -->
      <div class="flex w-full space-x-1">
        <button 
          v-for="n in [6, 7, 8, 9, 0]" 
          :key="n"
          :disabled="true"
          class="flex-1 h-8 flex items-center justify-center border border-gray-200 text-[16px] font-black bg-gray-50 text-gray-700 rounded shadow-sm opacity-50 cursor-not-allowed"
        >
          {{ n }}
        </button>
      </div>
    </div>

  </div> <!-- end of grid -->

  <!-- FULL-WIDTH ROW BELOW GRID for Captain Order -->
  <div class="w-full mt-1 px-2">
    <span class="block text-[14px] font-black text-[#0d4169] bg-white px-1 py-0 w-full text-center capitalize flex items-center justify-center">
      Captain Order
    </span>
  </div>

</div>

        <hr>
        <div ref="billContainer" class="p-4 pr-1 pl-1 flex-1 overflow-y-auto">          <!-- CURRENT BILL VIEW -->
          <template v-if="viewMode === 'bill'">
            <div >
               <!-- Print Failure Alert -->
               <div v-if="printFailures.length > 0" class="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg text-red-600 font-bold animate-pulse text-center shadow-sm">
                 <div class="text-sm">⚠️ Printing Failed</div>
                 <div v-for="dept in printFailures" :key="dept" class="text-[11px] mt-1">{{ dept }}</div>
                 <div class="text-[10px] mt-1 text-green-600">But the Order was saved.</div>
               </div>

               <!-- bill header titles -->
            <div class="flex items-center mb-2 space-x-2 font-semibold text-xs border-b pb-1 text-gray-500 capitalize tracking-wider">
              <span class="w-24 text-center">Qty</span>
              <span class="flex-1">Name</span>
              <span class="w-16 text-right pr-2">Status</span>
            </div>

            <!-- bill items -->
            <div
              v-for="item in sortedBillItems"
              :key="item.itemId || item.transferredItemId || item.localId"
              class="flex flex-col mb-2 border rounded-sm relative"
              :class="item.transferredQty > 0
                ? 'bg-green-100/70 border-green-300'
                : item.itemId && (item.ownNotPrintedCount || 0) > 0
                  ? 'bg-gray-50/20 border-blue-50/50'
                  : 'bg-gray-50/20 border-blue-50/50'"
            >
              <span 
                v-if="(item.itemId || item.transferredItemId) && ((item.transferredNotPrintedCount || 0) + (item.ownNotPrintedCount || 0)) > 0" 
                class="absolute -top-1.5 -left-1.4 z-10 bg-red-500 text-white text-[8px] w-3 h-3 flex items-center justify-center rounded-full font-bold shadow-sm"
                title="Quantity failed to print"
              >
                {{ (item.transferredNotPrintedCount || 0) + (item.ownNotPrintedCount || 0) }}
              </span>
              <div class="flex items-center p-1 px-0">
                <!-- Qty area -->
                <div class="w-24 flex items-center justify-center space-x-1">
                  <button 
                    v-if="!item.itemId && !item.transferredItemId" 
                    @click="changeQty(item, item.qty + 1)" 
                    class="text-green-600 text-sm px-1 font-bold"
                  >+</button>
                  <div v-else class="w-6"></div> <!-- spacer to match + button -->
                  
                  <input
                    type="number"
                    v-model.number="item.qty"
                    :readonly="!!item.itemId || !!item.transferredItemId"
                    @change="changeQty(item, item.qty)"
                    class="w-8 text-center text-sm border rounded focus:outline-none focus:border-[#add8e6] no-spinner"
                    :class="(item.itemId || item.transferredItemId) ? 'bg-gray-50 text-gray-500 cursor-not-allowed' : ''"
                  />
                  
                  <button 
                    @click="changeQty(item, item.qty - 1)" 
                    :disabled="(!canVoidOrder && (item.itemId || item.transferredItemId)) || (item.itemId || item.transferredItemId)"
                    :class="['text-red-600 text-sm px-1 font-bold', ((!canVoidOrder && (item.itemId || item.transferredItemId)) || (item.itemId || item.transferredItemId)) ? 'opacity-50 cursor-not-allowed' : '']"
                  >–</button>
                </div>

                <!-- Name area -->
                <div class="flex-1 min-w-0 pr-1 cursor-pointer relative group flex flex-col justify-center pl-1" @click="toggleExpansion(item)">
                  <span 
                    class="text-[13px] truncate leading-tight"
                    :class="{ 'text-red-600 font-bold': (item.itemId || item.transferredItemId) &&((item.ownNotPrintedCount || 0) > 0 || (item.transferredNotPrintedCount || 0) > 0)}"
                  >
                    {{ item.menu.name }}
                  </span>
                  <p  class="text-[9px] text-blue-500 absolute left-0 transform transition-transform duration-200" :class="[item.isExpanded ? 'rotate-180' : '', (!item.notPrintedCount || item.notPrintedCount === 0) ? 'bottom-0' : 'bottom-0']">▼</p>
                </div>


                <!-- Status area -->
                <div class="w-16 flex items-center justify-end pr-1">
                  <button 
                    v-if="!item.itemId && !item.transferredItemId"
                    @click="removeFromBill(item)" 
                    class="text-red-500 text-sm px-1"
                    title="Remove Item"
                  >×</button>

                  <span 
                    v-if="item.itemId || item.transferredItemId"
                    class="text-[9px] px-1.5 py-0.5 rounded-full font-bold capitalize"
                    :class="{
                      'bg-yellow-100 text-yellow-700': item.preparation_status === 'Pending',
                      'bg-blue-100 text-blue-700': item.preparation_status === 'Started',
                      'bg-green-100 text-green-700': item.preparation_status === 'Finished',
                      'bg-red-100 text-red-700': item.preparation_status === 'Out'
                    }"
                  >
                    {{ item.preparation_status || 'Pending' }}
                  </span>
                </div>
              </div>

              <!-- Ingredients Expansion Panel -->
              <Transition
                enter-active-class="transition duration-100 ease-out"
                enter-from-class="max-h-0 opacity-0"
                enter-to-class="max-h-60 opacity-100"
                leave-active-class="transition duration-75 ease-in"
                leave-from-class="max-h-60 opacity-100"
                leave-to-class="max-h-0 opacity-0"
              >
                <div v-if="item.isExpanded" class="p-3 bg-white border-t border-gray-50 overflow-hidden">
                  <div class="text-[14px] text-gray-800 capitalize tracking-wider mb-2">Note</div>
                  <input
                    v-model="item.note"
                    type="text"
                    :readonly="!!item.itemId || !!item.transferredItemId"
                    placeholder="Write note here..."
                    class="w-full mb-3 px-3 py-1.5 border border-gray-200 rounded text-sm outline-none focus:border-blue-400 focus:ring-1 focus:ring-blue-100 transition-all"
                   :class="(item.itemId || item.transferredItemId) ? 'bg-gray-50 text-gray-500 cursor-not-allowed' : ''"
                  />
                  
                  <div v-if="item.ingredients && item.ingredients.length">
                    <div class="text-[14px] text-gray-800 capitalize tracking-wider mb-2">Customize Ingredients</div>
                  <div class="grid grid-cols-1 gap-2">
  <div
    v-for="ing in item.ingredients"
    :key="ing.id"
    class="flex items-center space-x-2 p-1.5 hover:bg-gray-50 rounded transition-colors group"
    :class="(item.itemId || item.transferredItemId) ? 'opacity-70' : ''"
  >
    <input 
      type="checkbox" 
      v-model="ing.checked" 
      :disabled="!!item.itemId || !!item.transferredItemId"
      class="w-3.5 h-3.5 rounded text-blue-600 focus:ring-blue-500 border-gray-300 transition-all"
      :class="(item.itemId || item.transferredItemId) ? 'cursor-not-allowed bg-gray-100' : 'cursor-pointer'"
    />
    <span 
      class="text-xs text-gray-600 group-hover:text-gray-900 transition-colors truncate"
      :class="!ing.checked ? 'line-through text-gray-400' : ''"
    >
      {{ ing.name }}
    </span>
  </div>
</div>
                  </div>
                </div>
              </Transition>
            </div>

            <div v-if="billItems.length === 0" class="text-gray-500 text-sm italic py-4">
              No items added.
            </div>

            <div class="mt-4 mb-4 text-right">
              <!-- Waiter Transfer UI -->
              <div v-if="billItems.some(i => i.selected && i.orderId)" class="mb-4 p-2 bg-blue-50 rounded-sm border border-blue-100 animate-in slide-in-from-bottom-2">
                <div class="flex space-x-1">
                  <select 
                    v-model="selectedWaiterId"
                    class="flex-1 text-xs border border-gray-300 rounded-sm py-1 px-2 focus:ring-1 focus:ring-blue-500 outline-none bg-white"
                  >
                    <option value="" disabled>Select Waiter</option>
                    <option v-for="user in waiters" :key="user.id" :value="user.id">
                      {{ user.full_name || user.username }}
                    </option>
                  </select>
                  <button 
                    @click="transferSelectedItems"
                    :disabled="!canEditOrder"
                    :title="!canEditOrder ? 'You do not have Edit privileges for Management Order' : ''"
                    class="px-3 py-1 bg-blue-600 text-white rounded-sm text-xs font-bold hover:bg-blue-700 transition-colors shadow-sm disabled:bg-blue-400 disabled:cursor-not-allowed"
                  >
                    Transfer
                  </button>
                </div>
              </div>

              <!-- <div class="pt-2 pr-2 border-t border-gray-100">
                <span class="font-semibold text-gray-700">
                  Total: {{ totalPrice }} ብር
                </span>
              </div> -->
            </div>

            <!-- action buttons below total -->
            <div class="flex pr-2 pl-2 flex-col space-y-2">
              <!-- First Row: Clear, Delivery, Send -->
              <div class="flex space-x-1">
                <button 
                  @click="handleBackOrClear" 
                  class="flex-1 px-2 py-1 text-sm bg-red-500 text-white rounded-sm hover:bg-red-600"
                >
                  {{ currentEditingOrderId ? 'Back' : 'Clear' }}
                </button>
                <button 
                  :disabled="true"
                  :class="[
                    'flex-1 px-2 py-1 text-sm border rounded-sm transition-colors opacity-50 cursor-not-allowed',
                    isDelivery ? 'bg-orange-600 text-white border-orange-600' : 'bg-orange-700 text-white border-orange-500'
                  ]"
                >
                  Delivery
                </button>
                <button 
                  @click="sendOrder" 
                  :disabled="isSending || (currentEditingOrderId ? !canEditOrder : !canAddOrder)"
                  class="flex-1 px-2 py-1 text-sm bg-blue-600 text-white rounded-sm hover:bg-blue-600 disabled:bg-blue-400 disabled:cursor-not-allowed flex items-center justify-center min-h-[32px]"
                  :title="currentEditingOrderId ? (!canEditOrder ? 'You do not have Edit privileges for Management Order' : '') : (!canAddOrder ? 'You do not have Add privileges for Management Order' : '')"
                >
                  <span v-if="isSending" class="h-4 w-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                  <span v-else>{{ currentEditingOrderId ? 'Update' : 'Send' }}</span>
                </button>
              </div>

              <!-- Second Row: Delivery Company & Code (Conditional) -->
              <div v-if="isDelivery" class="flex space-x-2">
                <select 
                  v-model="deliveryCompany" 
                  class="flex-1 text-sm border border-gray-300 rounded-sm py-1 px-2 focus:ring-1 focus:ring-blue-500 outline-none"
                >
                  <option value="" disabled>Delivery Company</option>
                  <option v-for="c in deliveryCompanies" :key="c.id" :value="c.name">{{ c.name }}</option>
                </select>
                <input 
                  v-model="deliveryCode" 
                  type="text" 
                  placeholder="Code" 
                  class="w-20 text-sm border border-gray-300 rounded-sm py-1 px-2 focus:ring-1 focus:ring-blue-500 outline-none"
                />
              </div>
<!-- if user has privilege to approve order -->
              <div v-if="canApproveOrder" class="w-full pt-1">
                <button 
                  @click="confirmBill" 
                  class="w-full px-2 py-1 text-sm bg-green-600 text-white rounded-sm hover:bg-green-700 transition-color tracking-wider"
                >
                  Confirm
                </button>
              </div>
            </div>
            </div>
           
          </template>

          <!-- ALL ORDERS INLINE VIEW -->
          <template v-else>
            <div class="p-0">
              
              <table class="w-full">
                <thead class="bg-gray-50 sticky top-0">
                  <tr class="text-[11px]">
                    <th class="py-1 px-0.5 border-b w-[35%]">Date</th>
                    <th class="py-1 px-0.5 border-b w-[30%]">Name</th>
                    <th class="py-1 px-0.5 border-b w-[15%] text-center">Table</th>
                    <!-- <th class="py-1 px-0.5 border-b w-[20%] text-right pr-1">TP</th> -->
                  </tr>
                </thead>
                <tbody>
                  <!-- Today Orders -->
                  <tr 
                    v-for="order in todayOrders" 
                    :key="order.id" 
                    @click="viewOrder(order.id)"
                    class="hover:bg-yellow-200 cursor-pointer transition-colors text-[11px]"
                    :class="{
                      'bg-green-100/70 border-y border-green-300': order.transferStatus === 1,
                      'bg-orange-100/50': order.transferStatus === 0 && order.transferStatus !== 1 && !order.isAnyUnprinted
                    }"
                  >
                    <td class="py-1 px-0.5 border-b truncate">
                      <div class="flex items-center">
                        {{ order.createdAt ? order.createdAt.split('T')[0] : '---' }}
                      </div>
                    </td>
                    <td 
                      class="py-1 px-0.5 border-b truncate"
                      :class="{ 'text-red-600 font-bold italic': order.isAnyUnprinted }"
                    >{{ order.waiterName }}</td>
                    <td class="py-1 px-0.5 border-b text-center truncate">{{ order.table || '---' }}</td>
                    <!-- <td class="py-1 px-0.5 border-b font-bold text-right pr-1 truncate">{{ (order.totalPriceSum || 0).toFixed(2) }}</td> -->
                  </tr>

                  <!-- Before Today Title Row -->
                 <tr v-if="beforeTodayOrders.length > 0" class="text-center py-0">
  <td colspan="4"
      class="py-0 px-2 bg-red-600 border-y border-red-100 text-white font-bold  text-[13px] capitalize tracking-widest text-center align-middle">
    <div class="w-full text-center">
      Before Today Orders
    </div>
  </td>
</tr>

                  <!-- Before Today Orders -->
                  <tr 
                    v-for="order in beforeTodayOrders" 
                    :key="order.id" 
                    @click="viewOrder(order.id)"
                    class="hover:bg-yellow-200 cursor-pointer transition-colors text-[11px]"
                    :class="{
                      'bg-green-100/70 border-y border-green-300': order.transferStatus === 1,
                      'bg-orange-100/50': order.transferStatus === 0 && order.transferStatus !== 1 && !order.isAnyUnprinted
                    }"
                  >
                    <td class="py-1 px-0.5 border-b truncate">
                      <div class="flex items-center">
                        {{ order.createdAt ? order.createdAt.split('T')[0] : '---' }}
                      </div>
                    </td>
                    <td 
                      class="py-1 px-0.5 border-b truncate"
                      :class="{ 'text-red-600 font-bold italic': order.isAnyUnprinted }"
                    >{{ order.waiterName }}</td>
                    <td class="py-1 px-0.5 border-b text-center truncate">{{ order.table || '---' }}</td>
                    <td class="py-1 px-0.5 border-b font-bold text-right pr-1 truncate">{{ (order.totalPriceSum || 0).toFixed(2) }}</td>
                  </tr>

                  <tr v-if="orderGroups.length === 0" class="text-center">
                    <td colspan="4" class="py-4 text-center text-gray-500 italic">No orders found.</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>

  <!-- PAYMENT METHODS MODAL -->
<Transition name="fade">
  <div v-if="showPaymentModal" class="fixed inset-0 z-[100] flex items-center justify-center bg-slate-900/60 backdrop-blur-sm p-4">
    <!-- Increased width to md for 4-column layout -->
    <div class="bg-white rounded-xl shadow-2xl w-full max-w-md overflow-hidden animate-in zoom-in-95 duration-200">
      
      <!-- Compact Header -->
      <div class="px-4 py-3 flex justify-between items-center bg-[#0d4169]">
        <h3 class="text-sm font-bold text-white capitalize tracking-wide">Payment Methods</h3>
        <button @click="showPaymentModal = false" class="w-6 h-6 flex items-center justify-center rounded-full hover:bg-white/10 text-white transition-all text-lg">&times;</button>
      </div>

      <div class="p-4">
        <!-- Slim Amount Bar -->
        <div v-if="paymentPhase !== 'selection'" class="bg-slate-50 rounded-lg p-3 text-center mb-4 border border-slate-100">
          <span class="text-[10px] capitalize font-bold  tracking-wider">Total Amount</span>
          <div class="text-xl font-black text-[#0d4169] leading-none mt-1">
            {{ totalPrice }} 
          </div>
        </div>

        <!-- Phase 1: 4-Column Grid -->
        <div v-if="paymentPhase === 'selection'" class="pb-6">
          <div class="grid grid-cols-4 gap-2">
            <button 
              v-for="method in availablePaymentMethods" 
              :key="method.id"
              @click="handlePaymentSelection(method)"
              class="flex flex-col items-center justify-center p-3 border border-gray-200 rounded-lg hover:border-[#0d4169] hover:bg-blue-50/30 transition-all active:scale-95 bg-white group"
            >
              <div class="w-10 h-10 mb-1 group-hover:scale-110 transition-transform flex items-center justify-center overflow-hidden">
                <img v-if="method.logo" :src="method.logo" class="w-full h-full object-contain rounded-md p-1 border border-slate-100 bg-slate-50/50 shadow-sm">
                <div v-else class="w-10 h-10 rounded-md bg-slate-100 flex items-center justify-center text-sm font-black text-slate-400 uppercase border border-slate-200">
                  {{ method.name.substring(0, 2) }}
                </div>
              </div>
              <span class="text-[10px] font-bold text-slate-600 capitalize text-center leading-tight">{{ method.name }}</span>
            </button>
          </div>
          <div v-if="availablePaymentMethods.length === 0" class="py-10 text-center text-slate-400 italic text-sm">
            No active payment methods.
          </div>
        </div>

        <!-- Phase 2: Condensed Details / Processing -->
        <div v-else class="animate-in slide-in-from-right-2 duration-200">
          <div v-if="isProcessingPayment" class="flex flex-col items-center justify-center py-8 space-y-4">
            <div v-if="paymentSimulationStatus === 'waiting'" class="flex flex-col items-center animate-pulse">
              <div class="text-4xl mb-3">🕒</div>
              <p class="text-orange-500 font-black text-lg text-center tracking-tight">Waiting customer payment...</p>
              <p class="text-[10px] text-slate-400 mt-2">Please wait while we verify the transaction</p>
            </div>
            <div v-if="paymentSimulationStatus === 'success'" class="flex flex-col items-center">
              <div class="text-4xl mb-3 animate-bounce">✅</div>
              <p class="text-green-600 font-black text-lg text-center tracking-tight">Customer paid successfully</p>
              <p class="text-[10px] text-slate-400 mt-2">Processing completed</p>
            </div>
          </div>

          <div v-else>
            <div class="flex items-center space-x-3 mb-4 bg-slate-50 p-2 rounded-lg border border-slate-100">
               <div v-if="selectedPaymentMethod?.logo" class="w-8 h-8 rounded bg-white flex items-center justify-center overflow-hidden border border-slate-200">
                  <img :src="selectedPaymentMethod.logo" class="w-full h-full object-contain">
               </div>
               <div v-else class="w-8 h-8 rounded bg-white flex items-center justify-center text-xs font-bold text-slate-400 border border-slate-200 uppercase">
                  {{ selectedPaymentMethod?.name?.substring(0, 2) }}
               </div>
               <span class="text-sm font-bold text-[#0d4169] capitalize tracking-tight">{{ selectedPaymentMethod?.name }}</span>
            </div>
            
            <div class="space-y-4">
              <div class="flex flex-col items-start w-3/4 mx-auto">
                <label class="pl-4 text-[11px] font-bold text-slate-500 capitalize tracking-wider mb-1.5">
                  Customer Phone Number
                </label>
                <input 
                  v-model="customerPhone"
                  type="text"
                  placeholder="09..."
                  class="w-full px-3 py-1.5 bg-gray-50 border border-gray-200 rounded text-left text-sm focus:bg-white focus:border-[#0d4169] outline-none font-bold transition-all placeholder:font-normal"
                  @keyup.enter="markPaid(selectedPaymentMethod)"
                  autofocus
                />
              </div>

              <!-- Actions: Back (Left) & Pay Now (Right) -->
              <div class="flex items-center justify-between pt-3 border-t border-gray-100">
                <button 
                  @click="paymentPhase = 'selection'" 
                  class="pl-1 text-[13px] font-bold hover:text-slate-600 transition-all capitalize tracking-tight flex items-center"
                >
                  <span class="mr-1">←</span> Back
                </button>
                
                <button 
                  @click="markPaid(selectedPaymentMethod)" 
                  :disabled="isSending"
                  class="px-5 py-2 bg-green-600 text-white rounded text-[11px] font-bold hover:bg-green-700 shadow-sm active:scale-95 transition-all capitalize tracking-wider flex items-center justify-center min-w-[70px] min-h-[36px]"
                >
                  <span v-if="isSending" class="spinner"></span>
                  <span v-else>Send</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</Transition>
  <!-- TRANSFER REQUESTS MODAL -->
  <Transition name="fade">
    <div v-if="showTransferModal" class="fixed inset-0 z-[100] flex items-center justify-center bg-slate-900/60 backdrop-blur-sm p-4">
      <div class="bg-white rounded-xl shadow-2xl w-full max-w-2xl overflow-hidden animate-in zoom-in-95 duration-200">
        <!-- Modal Header -->
        <div class="px-5 py-3 flex justify-between items-center bg-[#0d4169]">
          <div>
            <h3 class="text-sm font-bold text-white tracking-wide">Transfer Requests</h3>
            <p class="text-[10px] text-white/70">{{ transferRequests.length }} pending request{{ transferRequests.length !== 1 ? 's' : '' }}</p>
          </div>
          <button @click="showTransferModal = false" class="w-7 h-7 flex items-center justify-center rounded-full hover:bg-white/10 text-white transition-all text-lg">&times;</button>
        </div>

        <!-- Cards Container -->
        <div class="p-4 max-h-[70vh] overflow-y-auto custom-scrollbar">
          <div v-if="transferRequests.length === 0" class="py-16 text-center text-gray-400 italic text-sm">
            No transfer requests pending.
          </div>
          <div v-else class="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div 
              v-for="req in transferRequests"
              :key="req.id"
              class="border border-gray-200 rounded-lg overflow-hidden bg-white shadow-sm flex flex-col"
            >
              <!-- Card Header -->
              <div class="bg-slate-50 border-b border-gray-200 px-3 py-2">
                <div class="flex items-center justify-between">
                  <span class="text-[13px] font-bold text-[#0d4169] capitalize">{{ req.waiter }}</span>
                  <span class="text-[10px] text-slate-400">{{ req.date }}</span>
                </div>
                <div class="flex items-center mt-0.5 space-x-3">
                  <span class="text-[10px] text-slate-500">Table: <span class="font-bold text-slate-700">{{ req.table }}</span></span>
                  <span class="text-[10px] text-slate-500">{{ req.items.length }} item{{ req.items.length !== 1 ? 's' : '' }}</span>
                </div>
              </div>

              <!-- Card Items Table -->
              <table class="w-full text-[11px] flex-1">
                <thead class="bg-gray-50">
                  <tr>
                    <th class="py-1 px-2 border-b text-left w-[50%]">Menu</th>
                    <th class="py-1 px-2 border-b text-center w-[20%]">Qty</th>
                    <th class="py-1 px-2 border-b text-center w-[30%]">
                      <input type="checkbox" @change="toggleAllItems(req, $event.target.checked)" class="cursor-pointer" title="Select all" />
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in req.items" :key="item.id" class="hover:bg-blue-50/50 transition-colors">
                    <td class="py-1.5 px-2 border-b truncate">{{ item.menuName }}</td>
                    <td class="py-1.5 px-2 border-b text-center">{{ item.qty }}</td>
                    <td class="py-1.5 px-2 border-b text-center">
                      <input type="checkbox" v-model="item.selected" class="cursor-pointer" />
                    </td>
                  </tr>
                </tbody>
              </table>

              <!-- Card Actions -->
              <div class="bg-gray-50 px-3 pl-2 py-2 border-t border-gray-100 flex flex-col space-y-2">
                
                <!-- Buttons at the top -->
                <div class="flex justify-end space-x-2 border-b border-gray-100 pb-1 gap-7">
                  <button
                    @click="toggleTransferAction(req.id, true)"
                    class="px-3 py-1 text-[11px] font-bold border rounded transition-all bg-green-50 text-green-600 border-green-200 hover:bg-green-600 hover:text-white"
                  >
                    Accept
                  </button>

                  <button
                    @click="() => {
                      let selected = req.items.filter(i => i.selected).map(i => i.transferId)
                      if (selected.length === 0) selected = req.items.map(i => i.transferId)
                      if (selected.length && confirmAction('Are you sure you want to reject the selected items?')) {
                        rejectTransfer(selected.join(','), req.id)
                      }
                    }"
                    class="px-3 py-1 text-[11px] font-bold border rounded transition-all bg-red-50 text-red-600 border-red-200 hover:bg-red-600 hover:text-white"
                  >
                    Reject
                  </button>
                </div>

                <!-- Action section (Hidden by default) -->
                <template v-if="transferUIState[req.id]?.showAction">
                  <!-- Choose Table View -->
                  <div v-if="!transferUIState[req.id].action || transferUIState[req.id].action === 'Merge'" class="w-full pt-1">
                    <span class="text-[11px] font-bold text-gray-500 block mb-1.5 text-left">Select existing table:</span>
                    <div class="flex flex-col w-full divide-y divide-gray-100 border-b border-gray-100 mb-2">
                      <button 
                        v-for="t in pendingTables" 
                        :key="t"
                        @click="transferUIState[req.id].action = 'Merge'; transferUIState[req.id].targetTable = t;"
                        :class="[
                          'px-3 py-2.5 text-[11px] font-bold transition-all w-full flex justify-between items-center',
                          transferUIState[req.id].action === 'Merge' && transferUIState[req.id].targetTable === t
                            ? 'bg-blue-600 text-white'
                            : 'bg-white text-gray-700 hover:bg-blue-50'
                        ]"
                      >
                        <span>Table Number</span>
                        <span>{{ t }}</span>
                      </button>
                    </div>
                    <button 
                      @click="transferUIState[req.id].action = 'New Table'; transferUIState[req.id].targetTable = '';"
                      class="px-2 py-1 text-[11px] font-bold text-[#0d4169] hover:underline transition-all flex items-center justify-start"
                    >
                      <span class="mr-1 shrink-0 bg-[#0d4169]/10 text-[#0d4169] rounded-full w-4 h-4 flex flex-col justify-center items-center text-[10px] leading-none">+</span> New table
                    </button>
                  </div>

                  <!-- New Table Keypad (Numeric input) -->
                  <div v-if="transferUIState[req.id]?.action === 'New Table'" class="flex flex-col space-y-1">
                    <div class="flex items-center justify-between mb-1">
                      <span class="text-[11px] font-bold text-gray-500">New Table</span>
                      <button @click="transferUIState[req.id].action = ''; transferUIState[req.id].targetTable = '';" class="text-[10px] text-[#0d4169] hover:underline font-bold">← Back</button>
                    </div>
                    <div class="flex items-center justify-between border border-gray-200 rounded px-2 py-0.5 bg-white shadow-sm">
                        <span class="text-[12px] font-black text-[#0d4169]">Table: {{ transferUIState[req.id]?.targetTable || '---' }}</span>
                        <button @click="clearTransferTable(req.id)" class="text-red-500 text-sm hover:text-red-700 font-bold">×</button>
                    </div>
                    <!-- Keypad rows distributed across the whole row -->
                    <div class="grid grid-cols-5 gap-2 w-full">
                      <button 
                        v-for="n in [1, 2, 3, 4, 5]" 
                        :key="n"
                        @click="setTransferTableDigit(req.id, n)"
                        class="w-full h-9 flex items-center justify-center border border-gray-200 text-[13px] font-black bg-gray-50 hover:bg-white text-gray-700 rounded shadow-sm hover:shadow active:translate-y-px transition-all"
                      >
                        {{ n }}
                      </button>
                      <button 
                        v-for="n in [6, 7, 8, 9, 0]" 
                        :key="n"
                        @click="setTransferTableDigit(req.id, n)"
                        class="w-full h-9 flex items-center justify-center border border-gray-200 text-[13px] font-black bg-gray-50 hover:bg-white text-gray-700 rounded shadow-sm hover:shadow active:translate-y-px transition-all"
                      >
                        {{ n }}
                      </button>
                    </div>
                  </div>

                  <!-- Final Confirmation Button to use acceptTransfer -->
                  <div v-if="transferUIState[req.id]?.action" class="pt-2 border-t border-gray-100 mt-2">
                    <button
                      @click="() => {
                        const dest = resolveTransferDestination(req.id)
                        if (!dest) return
                        let selected = req.items.filter(i => i.selected).map(i => i.transferId)
                        if (selected.length === 0) selected = req.items.map(i => i.transferId)
                        // const action = transferUIState[req.id]?.action
                        // const target = transferUIState[req.id]?.targetTable
                        // && confirmAction(`Accept transfer to ${action}: Table ${target}?`)
                        if (selected.length) {
                          acceptTransfer(selected.join(','), dest.tableNumber, dest.orderGroupId, req.id)
                        }
                      }"
                      class="w-full py-1 text-[11px] font-bold border rounded transition-all bg-green-600 text-white border-green-700 hover:bg-green-700 shadow-sm"
                    >
                      Confirm Accept
                    </button>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>

        <!-- Modal Footer -->
        <div class="bg-gray-50 px-5 py-3 flex justify-end border-t border-gray-100">
          <button 
            @click="showTransferModal = false" 
            class="px-5 py-1.5 bg-[#0d4169] text-white rounded text-xs font-bold hover:bg-[#0a3354] transition-all"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </Transition>
  
  <!-- Toast Notification -->
  <Transition name="toast">
    <div v-if="toast.show" class="fixed top-4 right-4 z-[1000] max-w-sm">
      <div 
        :class="[
          'px-6 py-3 rounded-lg shadow-2xl text-white flex items-center gap-3 min-w-[300px]',
          toast.type === 'success' ? 'bg-green-600' : 'bg-red-600'
        ]"
      >
        <span v-if="toast.type == 'success'">✅</span>
        <span v-else>❌</span>
        <span class="font-medium">{{ toast.message }}</span>
      </div>
    </div>
  </Transition>

</template>

<script setup>
import { ref, computed, onMounted, watch, nextTick } from 'vue'
import store from '../../store'
import { apiFetch } from '../../utils/api'

// Helper for template to use window.confirm
const confirmAction = (msg) => window.confirm(msg)


const currentUser = computed(() => store.getters.currentUser)

const userPrivileges = computed(() => {
  if (!currentUser.value?.privilege) return {}
  return typeof currentUser.value.privilege === 'string' 
    ? JSON.parse(currentUser.value.privilege) 
    : currentUser.value.privilege
})

const hasAdminPrivilege = computed(() => userPrivileges.value?.all === true)

const canAddOrder = computed(() => {
  if (hasAdminPrivilege.value) return true
  const mgt = userPrivileges.value?.['Management Order'] || userPrivileges.value?.managementOrder
  const orders = userPrivileges.value?.Orders || userPrivileges.value?.orders
  return !!(mgt?.Add ?? orders?.Add)
})

const canEditOrder = computed(() => {
  if (hasAdminPrivilege.value) return true
  const mgt = userPrivileges.value?.['Management Order'] || userPrivileges.value?.managementOrder
  const orders = userPrivileges.value?.Orders || userPrivileges.value?.orders
  return !!(mgt?.Edit ?? orders?.Edit)
})

const canVoidOrder = computed(() => {
  if (hasAdminPrivilege.value) return true
  const mgt = userPrivileges.value?.['Management Order'] || userPrivileges.value?.managementOrder
  const orders = userPrivileges.value?.Orders || userPrivileges.value?.orders
  return !!(mgt?.Void ?? orders?.Void)
})

const canApproveOrder = computed(() => {
  if (hasAdminPrivilege.value) return true
  const mgt = userPrivileges.value?.['Management Order'] || userPrivileges.value?.managementOrder
  const orders = userPrivileges.value?.Orders || userPrivileges.value?.orders
  return !!(mgt?.Approve ?? orders?.Approve)
})

// Check if currently editing an order that belongs strictly to the user
const isOwnOrder = computed(() => {
  if (!currentEditingOrderId.value) return true // New orders belong to user
  const order = orderGroups.value.find(o => o.id === currentEditingOrderId.value)
  if (!order) return false
  const uid = currentUser.value?.id || currentUser.value?.sub
  return order.waiterId === uid
})

const companyId = computed(() => currentUser.value?.companyId || currentUser.value?.company_id || null)
const branchId = computed(() => currentUser.value?.branchId || currentUser.value?.branch_id || null)
const companyName = computed(() => currentUser.value?.company?.name || '')
  
const departments = ref([])
const menus = ref([])
const searchTerm = ref('')
const selectedDept = ref(null)
const selectedSub = ref(null)

// Toast notification state
const toast = ref({ show: false, message: '', type: 'success' })

// Toast helper function
function showToast(message, type = 'success') {
  toast.value = { show: true, message, type }
  setTimeout(() => {
    toast.value.show = false
  }, 3000)
}

async function loadDepartments() {
  if (!companyId.value) {
    alert('Company ID not found in user profile.')
    return
  }

  try {
    let endpoint = `/departments/company/${companyId.value}`
    if (branchId.value) {
      endpoint = `/departments/branch/${branchId.value}`
    }
    
    const response = await apiFetch(endpoint, { method: 'GET' })
    if (!response.ok) {
      const data = await response.json().catch(() => ({}))
      throw new Error(data.message || 'Failed to load departments')
    }
    const data = await response.json()
    // Filter departments to only show those with a printer IP
    departments.value = (Array.isArray(data) ? data : [])
      .filter(d => d.printerIP)
      .map(d => ({
        ...d,
        subDepartments: Array.isArray(d?.subDepartments)
          ? d.subDepartments.filter(sd => sd?.status === 1)
          : d?.subDepartments
      }))
    departments.value = departments.value.filter(d => d.status === 1);
    // console.log('POS departments loaded (filtered by printerIP):', departments.value)
  } catch (err) {
    alert(err.message || 'Failed to load departments')
  } 
}

// Load all menus once, filtered by company/branch (backend: /menu-lists)
async function loadMenus() {
  if (!companyId.value && !branchId.value) return
  try {
    const params = new URLSearchParams()
    if (branchId.value) params.append('branchId', branchId.value)
    else if (companyId.value) params.append('companyId', companyId.value)

    const response = await apiFetch(`/menu-lists?${params.toString()}`, { method: 'GET' })
    if (!response.ok) {
      console.error('Failed to load menus')
      return
    }
    const data = await response.json().catch(() => [])
    const list = Array.isArray(data) ? data : []
    menus.value = list.map((m) => {
      const totalPrice = Number(m.totalPrice ?? m.total_price ?? 0) || 0
      return {
        ...m,
        totalPrice,
        total_price: totalPrice,
        price: Number(m.price ?? 0) || 0,
        addition: Number(m.addition ?? 0) || 0,
        vat: Number(m.vat ?? 0) || 0
      }
    })
  } catch (err) {
    console.error('Error loading menus:', err)
  }
}

onMounted(() => {
  loadDepartments()
  loadMenus()
  loadPaymentMethods()
  loadDeliveryCompanies()
  loadTableMandatorySetting()
})
const billItems = ref([])
const printFailures = ref([])
const tableNumber = ref('mgt')
const tableError = ref(false)
const isTableMandatory = ref(1)
const orders = ref([])
const viewMode = ref('bill') // 'bill' or 'orders'
const currentEditingOrderId = ref(null)
const originalWaiterId = ref(null)
const selectedWaiter = ref('')
const selectedOrderDate = ref('')
const isDelivery = ref(false)
const deliveryCompany = ref('')
const deliveryCode = ref('')
const deliveryCompanies = ref([])

const showPaymentModal = ref(false)
const paymentPhase = ref('selection') // 'selection' or 'details'
const billContainer = ref(null)

function scrollToBottom() {
  if (billContainer.value) {
    billContainer.value.scrollTop = billContainer.value.scrollHeight
  }
}
const paymentMethods = ref([])

const availablePaymentMethods = computed(() => {
  if (!isDelivery.value || !deliveryCompany.value) {
    return paymentMethods.value.filter(m => m.name.toLowerCase() !== 'delivery')
  }
  return paymentMethods.value
})

async function loadPaymentMethods() {
  try {
    const res = await apiFetch('/settings/payment-methods')
    if (res.ok) {
      const data = await res.json()
      // Only show active payment methods
      paymentMethods.value = data.filter(m => m.isActive === 1)
    }
  } catch (err) {
    console.error('Error loading payment methods:', err)
  }
}

async function loadDeliveryCompanies() {
  try {
    const res = await apiFetch('/settings/delivery-companies')
    if (res.ok) {
      const data = await res.json()
      // Only show active delivery companies
      deliveryCompanies.value = data.filter(c => c.isActive === 1)
    }
  } catch (err) {
    console.error('Error loading delivery companies:', err)
  }
}

async function loadTableMandatorySetting() {
  try {
    const res = await apiFetch('/settings')
    if (!res.ok) return
    const data = await res.json()
    isTableMandatory.value = Number(data?.is_table_mandatory ?? 1) === 1 ? 1 : 0
  } catch (err) {
    console.error('Failed to read table mandatory setting:', err)
  }
}

const selectedPaymentMethod = ref(null)
const customerPhone = ref('')
const isProcessingPayment = ref(false)
const paymentSimulationStatus = ref('waiting') // 'waiting' or 'success'

const showTransferModal = ref(false)
const isSending = ref(false)
const transferRequests = ref([])
const transferUIState = ref({}) // { [requestId]: { action: 'Merge' | 'New Table', targetTable: string } }
const waiters = ref([])
const selectedWaiterId = ref('')
// const transferBadgeCount = computed(() => transferRequests.value.length)

const pendingTables = computed(() => {
  if (!Array.isArray(orderGroups.value)) return []
  
  const uid = currentUser.value?.id || currentUser.value?.sub
  
  // Strictly filter for the current user's own tables. 
  // When accepting a transfer, the user should only merge into their own active tables.
  const filteredGroups = orderGroups.value.filter(g => {
    if (!g.table) return false
    return String(g.waiterId) === String(uid)
  })

  const tables = filteredGroups.map(g => g.table)
  return [...new Set(tables)].sort((a, b) => a.localeCompare(b, undefined, { numeric: true }))
})

function setTransferTableDigit(reqId, digit) {
  if (!transferUIState.value[reqId]) {
    transferUIState.value[reqId] = { action: 'New Table', targetTable: '' }
  }
  transferUIState.value[reqId].targetTable += digit.toString()
}

function clearTransferTable(reqId) {
  if (transferUIState.value[reqId]) {
    transferUIState.value[reqId].targetTable = ''
  }
}

function toggleTransferAction(reqId, state) {
  if (transferUIState.value[reqId]) {
    transferUIState.value[reqId].showAction = state
  }
}

async function loadWaiters() {
  try {
    const endpoint = branchId.value ? `/users/branch/${branchId.value}` : `/users/company/${companyId.value}`
    const response = await apiFetch(endpoint)
    if (response.ok) {
      waiters.value = await response.json()
    }
  } catch (err) {
    console.error('Failed to load waiters', err)
  }
}

function getOrderUpdatedAtForGroup(orderGroupId = currentEditingOrderId.value) {
  const group = orders.value.find(order => String(order.id) === String(orderGroupId))
  if (!group || !Array.isArray(group.items)) return []
  return group.items
    .map(item => ({ id: item.itemId ?? item.id, updatedAt: item.updatedAt }))
    .filter(item => item.id != null && typeof item.updatedAt === 'string')
}

async function transferSelectedItems() {
  const selectedOrderIds = billItems.value
    .filter(item => item.selected && item.orderId)
    .flatMap(item => {
      const ids = []
      if (item.itemId) ids.push(item.itemId)
      if (item.transferredItemId) ids.push(item.transferredItemId)
      return ids
    });

  if (selectedOrderIds.length === 0) {
    showToast('No saved items selected for transfer', 'error');
    return;
  }
  if (!selectedWaiterId.value) {
    showToast('Please select a waiter', 'error');
    return;
  }

  try {
    const response = await apiFetch('/order-transfers/bulk', {
      method: 'POST',
      body: JSON.stringify({
        senderId: currentUser.value.id,
        receiverId: selectedWaiterId.value,
        orderIds: selectedOrderIds,
        orderUpdatedAt: getOrderUpdatedAtForGroup(),
      })
    });

    if (response.ok) {
      showToast('Transfer request sent successfully', 'success');
      selectedWaiterId.value = '';
      
      // Do not remove items immediately; just uncheck them so they remain in the list until accepted
      billItems.value.forEach(item => { 
        if (item.selected) item.selected = false; 
      });

      // Refresh orders
      await fetchOrders(false);
      clearBillAreaOnly()
      // If bill is empty, clear it
      if (billItems.value.length === 0) {
        clearBill(true);
      }
    } else {
      const errorData = await response.json().catch(() => ({}))
      showToast(errorData.message || 'Failed to create transfer request', 'error');
    }
  } catch (err) {
    console.error('Transfer failed', err);
    showToast('Transfer failed', 'error');
  }
}



function toggleAllItems(req, checked) {
  req.items.forEach(item => { item.selected = checked })
}

async function fetchTransferRequests() {
  try {
    const response = await apiFetch(`/order-transfers?receiverId=${currentUser.value?.id}`)
    if (response.ok) {
      const data = await response.json()
      // Preserve local selections and initialize UI state
      data.forEach(req => {
        const existingReq = transferRequests.value.find(r => r.id === req.id)
        if (existingReq && existingReq.items) {
          req.items.forEach(newItem => {
            const existingItem = existingReq.items.find(i => i.transferId === newItem.transferId)
            if (existingItem && existingItem.selected) {
              newItem.selected = existingItem.selected
            }
          })
        }
        if (!transferUIState.value[req.id]) {
          transferUIState.value[req.id] = { action: '', targetTable: '', showAction: false }
        }
      })
      transferRequests.value = data
    }
  } catch (error) {
    console.error('Failed to fetch transfers:', error)
  }
}

async function acceptTransfer(transferIdString, tableNumber = null, orderGroupId = null, reqId = null) {
  try {
    const body = { isAccepted: 1, receiverId: currentUser.value?.id }
    if (tableNumber) body.tableNumber = tableNumber
    if (orderGroupId) body.orderGroupId = orderGroupId
    const request = transferRequests.value.find(item => String(item.id) === String(reqId))
    body.orderUpdatedAt = request?.orderUpdatedAt || []

    const response = await apiFetch(`/order-transfers/${transferIdString}/status`, {
      method: 'PATCH',
      body: JSON.stringify(body)
    })
    if (response.ok) {
      showToast('Transfer accepted', 'success')
      // Clear specify UI state to close the action drawer
      if (reqId) {
        delete transferUIState.value[reqId]
      }
      await fetchTransferRequests()
      if(transferRequests.value.length === 0){ showTransferModal.value = false}
      await fetchOrders()
    } else {
      const errorData = await response.json().catch(() => ({}))
      showToast(errorData.message || 'Failed to accept transfer', 'error')
    }
  } catch (error) {
    console.error('Accept transfer failed:', error)
    showToast('Failed to accept transfer', 'error')
  }
}

// Resolve destination params for a transfer request base on action
function resolveTransferDestination(reqId) {
  const state = transferUIState.value[reqId]
  if (!state) return null

  const action = state.action
  const targetTable = state.targetTable

  if (action === 'Merge') {
    if (!targetTable) {
      showToast('Please select an existing table', 'error')
      return null
    }
    // Find the orderGroupId of the selected table
    const matchingOrder = orderGroups.value.find(o => String(o.table) === String(targetTable))
    if (!matchingOrder) {
      showToast('Selected table not found in active orders', 'error')
      return null
    }
    return { tableNumber: targetTable, orderGroupId: matchingOrder.id }
  }

  if (action === 'New Table') {
    if (!targetTable) {
      showToast('Please enter a new table number', 'error')
      return null
    }
    // Validate new table does not already exist
    const exists = pendingTables.value.some(t => String(t) === String(targetTable))
    if (exists) {
      showToast(`Table ${targetTable} already exists. Choose Merge instead.`, 'error')
      return null
    }
    return { tableNumber: targetTable, orderGroupId: `group-table-${targetTable}-${Date.now()}` }
  }

  showToast('Please select an action (Merge or New Table)', 'error')
  return null
}

async function rejectTransfer(transferIdString, reqId = null) {
  try {
    const response = await apiFetch(`/order-transfers/${transferIdString}/status`, {
      method: 'PATCH',
      body: JSON.stringify({ isAccepted: 2 })
    })
    if (response.ok) {
      showToast('Transfer rejected', 'info')
      if (reqId) {
        delete transferUIState.value[reqId]
      }
      await fetchTransferRequests()
    } else {
      showToast('Failed to reject transfer', 'error')
    }
  } catch (error) {
    console.error('Reject transfer failed:', error)
    showToast('Failed to reject transfer', 'error')
  }
}

watch(showTransferModal, (newVal) => {
  if (newVal) {
    fetchTransferRequests()
  } else {
    // Reset all UI states when closing
    transferUIState.value = {}
    transferRequests.value.forEach(req => {
      if (req.items) {
        req.items.forEach(item => { if (item.selected) item.selected = false })
      }
    })
  }
})

// currentUser moved to top
function persistOrders() {
  localStorage.setItem('posOrders', JSON.stringify(orders.value))
}

function syncExcludes() {
  billItems.value.forEach(item => {
    if (item.ingredients?.length) {
      item.excludeIngredients = item.ingredients.filter(ing => !ing.checked).map(ing => ing.name).join(', ')
    }
  })
}

function normalizeIngredientType(v) {
  const s = String(v || '').toLowerCase()
  if (s.includes('product')) return 'product'
  if (s.includes('item')) return 'item'
  return s
}

function buildOrderIngredientAndAmount(item) {
  const snapshot = item?.menu?.latestSavedMenuRecipe || null
  const raw = snapshot?.ingredient_and_amount ?? snapshot?.ingredientAndAmount ?? null
  if (!Array.isArray(raw)) return null

  const uncheckedKeys = new Set(
    Array.isArray(item?.ingredients)
      ? item.ingredients
          .filter(ing => ing && ing.checked === false)
          .map(ing => {
            const id = Number(ing.sourceId ?? ing.Id ?? ing.id)
            const t = normalizeIngredientType(ing.sourceType ?? ing.type)
            return Number.isFinite(id) ? `${t}:${id}` : null
          })
          .filter(Boolean)
      : []
  )

  const filtered = raw.filter(entry => {
    const id = Number(entry?.Id ?? entry?.id)
    const t = normalizeIngredientType(entry?.type)
    if (!Number.isFinite(id) || !t) return true
    return !uncheckedKeys.has(`${t}:${id}`)
  })

  // Return exactly as `{ Id, type, amount }`
  return filtered.map(entry => ({
    Id: Number(entry?.Id ?? entry?.id),
    type: entry?.type,
    amount: Number(entry?.amount),
  }))
}

onMounted(() => {
  // const saved = localStorage.getItem('posOrders')
  // if (saved) orders.value = JSON.parse(saved)

  // Auto-fill waiter from logged-in user
  if (currentUser.value) {
    selectedWaiter.value = currentUser.value.full_name || currentUser.value.username || ''
  }

  // Pre-fetch orders to enable table number validation
  fetchOrders(false)
  loadWaiters()
  fetchTransferRequests()

  // Periodic refresh for badges
  setInterval(fetchTransferRequests, 30000)
})

async function fetchOrders(switchView = true) {
  if (switchView) {
    printFailures.value = []
  }
  try {
    const waiterIdParam = (currentUser.value?.id || '')
    const today = new Date().toISOString().split('T')[0]
    
    // Fetch only pending (isPaid=0) staff orders for the current user/waiter
    const query = `/orders?companyId=${companyId.value}&branchId=${branchId.value || ''}&waiterId=${waiterIdParam}&isPaid=0&isForStaff=Staff&startDate=${today}&endDate=${today}`
    const response = await apiFetch(query)
    
    if (!response.ok) {
        console.error('Fetch orders failed:', response.statusText)
        showToast('Failed to fetch live orders.', 'error')
        orders.value = []
        if (switchView) viewMode.value = 'orders'
        return
    }

    const data = await response.json()
    
    // Safety check: ensure data is an array
    if (!Array.isArray(data)) {
      console.error('Expected array from fetchOrders, but got:', data)
      showToast('Live orders data is invalid.', 'error')
      orders.value = []
      if (switchView) viewMode.value = 'orders'
      return
    }

    // Group backend items by orderGroupId (bill)
    const groupsMap = {}
    data.forEach(item => {
      const gid = item.orderGroupId || item.createdAt || 'default'
      if (!groupsMap[gid]) {
        groupsMap[gid] = {
          id: gid,
          createdAt: item.createdAt,
          waiterName: item.waiterFullName || 'Unknown',
          waiterId: item.waiterId,
          table: item.tableNumber,
          isPaid: item.isPaid,
          isDelivery: !!item.deliveryId, // or item.isDelivery if it exists, but usually its by presence of deliveryId
          deliveryId: item.deliveryId,
          deliveryCode: item.deliveryCode,
          dailyOrderNo: item.dailyOrderNo,
          transferStatus: null, // 0: pending, 1: accepted
          isPrinted: 1, // Will be set to 0 if any item is 0
          items: []
        }
      }

      // DEBUG: console.log('Checking item print status:', item.id, item.isPrinted)
      if (item.isPrinted === 0) {
        groupsMap[gid].isPrinted = 0
        // console.log('Marking group as failed print:', gid)
      }

      // Track transfer status for the group
      if (item.transfers) {
        if (item.transfers.some(t => t.isAccepted === 0 && t.receiverId === currentUser.value?.id)) {
          groupsMap[gid].transferStatus = 0;
        } else if (item.transfers.some(t => t.isAccepted === 1 && t.receiverId === currentUser.value?.id)) {
          groupsMap[gid].transferStatus = 1;
        }
      }

      groupsMap[gid].items.push({
        itemId: item.id, // Database record ID
        updatedAt: item.updatedAt,
        menuId: item.menuId,
        menu: item.menu, // Full menu object with departmentId
        name: item.menu?.name || 'Item',
        qty: item.quantity,
        price: item.unitPrice,
        excludeIngredients: item.excludeIngredients || '',
        note: item.note || '',
        isPrinted: item.isPrinted,
        notPrintedCount: item.not_printed_count || 0,
        transfers: item.transfers || [],
        preparation_status: item.preparation_status
      })
    })
    
    orders.value = Object.values(groupsMap).sort((a,b) => new Date(a.createdAt) - new Date(b.createdAt))
    if (switchView) viewMode.value = 'orders'
  } catch (err) {
    console.error('Failed to fetch orders:', err)
    orders.value = []
    if (switchView) viewMode.value = 'orders'
  }
}

const sortedBillItems = computed(() => {
  const existingItems = billItems.value.filter(item => item.itemId || item.transferredItemId)
  const newItems = billItems.value.filter(item => !item.itemId && !item.transferredItemId)

  const sortedExisting = [...existingItems].sort((a, b) => {
    const nameA = (a.menu?.name || '').toLowerCase()
    const nameB = (b.menu?.name || '').toLowerCase()
    return nameA.localeCompare(nameB)
  })

  return [...newItems.reverse(), ...sortedExisting]
})

function selectDept(dept) {
  selectedDept.value = dept
  // When department is clicked, clear sub selection so we see ALL menus of that department
  selectedSub.value = null
}

function selectSub(sub) {
  selectedSub.value = sub
}

const filteredMenus = computed(() => {
  // 1. First, only consider menus that are active (status=1) and isForStaff=1
  const activeMenus = menus.value.filter(m => (m.status === 1 || m.status === undefined) && Number(m.isForStaff ?? m.is_for_staff) === 1)

  // 2. If no department selected AND no search term, show nothing (welcome message)
  if (!selectedDept.value && !searchTerm.value) {
    return []
  }

  // 3. Apply search or category filters
  let result = []
  if (searchTerm.value) {
    // Search across all active menus
    const term = searchTerm.value.toLowerCase()
    result = activeMenus.filter(m => 
      m.name.toLowerCase().includes(term) || 
      (m.code && m.code.toLowerCase().includes(term))
    )
  } else if (selectedSub.value) {
    // Filter active menus by sub-department
    const subId = selectedSub.value.id
    result = activeMenus.filter(m => {
      const menuSubId = m.subDepartmentId ?? m.sub_department_id ?? m.subDeptId ?? m.sub_dept_id
      return menuSubId === subId
    })
  } else if (selectedDept.value) {
    // Filter active menus by department
    const deptId = selectedDept.value.id
    result = activeMenus.filter(m => {
      const menuDeptId = m.departmentId ?? m.department_id ?? m.deptId ?? m.dept_id
      return menuDeptId === deptId
    })
  }

  return result
})

function addToBill(menu) {
  // Strict Ownership Check: Only the designated waiter can add items to an existing bill.
  if (currentEditingOrderId.value && !isOwnOrder.value) {
    showToast('You cannot add items to another waiter\'s order', 'error')
    return
  }

  // Auto-switch to bill view
  viewMode.value = 'bill'
  printFailures.value = []

  // Merge ONLY with an existing 'new' item (unsaved, no database IDs)
  const existingNew = billItems.value.find(b => 
    !b.itemId && !b.transferredItemId &&
    b.menu.id === menu.id && 
    (b.note || '') === '' && 
    (b.excludeIngredients || '') === ''
  )
  if (existingNew) {
    existingNew.qty++
    existingNew.ownNotPrintedCount = (existingNew.ownNotPrintedCount || 0) + 1
    existingNew.notPrintedCount = (existingNew.notPrintedCount || 0) + 1
    existingNew.ownQty = (existingNew.ownQty || 0) + 1
    return
  }
  const recipeIngs = menu.recipes?.recipe_ingredients || []
  const activeIngs = recipeIngs.filter(ri => ri.is_active === 1).map(ri => ({
    id: ri.id,
    name: ri.items?.itemName || ri.item?.name || ri.products?.name || ri.product?.name || 'Unknown',
    checked: true
  }))
  billItems.value.push({ 
    localId: `local-${Date.now()}-${Math.floor(Math.random() * 1000)}`,
    menu, 
    qty: 1,
    originalQty: 0,
    orderId: null,
    orderNumber: null,
    excludeIngredients: '',
    ingredients: activeIngs,
    isExpanded: false,
    selected: false,
    note: '',
    transferredNotPrintedCount: 0,
    ownNotPrintedCount: 1,
    notPrintedCount: 1, // Truly new quantity
    isAcceptedTransfer: false,
    transferredItemId: undefined,
    transferredQty: 0,
    ownQty: 1
  })
}

async function removeFromBill(item) {
  if (!item) return

  // Prevent removal of existing items in Management Order
  if (item.itemId || item.transferredItemId) {
    showToast('Existing items cannot be removed from a management order.', 'error')
    return
  }

  const confirmMsg = `Are you sure you want to remove ${item.menu.name}?`
  if (!window.confirm(confirmMsg)) return

  // Identify all saved item IDs (own and transferred)
  const idsToDelete = [item.itemId, item.transferredItemId].filter(Boolean)

  if (idsToDelete.length > 0) {
    if (!canVoidOrder.value) {
      showToast('You do not have privilege to remove saved items.', 'error')
      return
    }
    try {
      // Parallel deletion for all database records associated with this row
      await Promise.all(idsToDelete.map(id => 
        apiFetch(`/orders/${id}`, {
          method: 'DELETE',
          body: JSON.stringify({
            adminId: currentUser.value?.id,
            adminName: currentUser.value?.full_name || currentUser.value?.username || null
          })
        })
      ))
      showToast('Item removed successfully', 'success')
    } catch (err) {
      console.error('Failed to delete item:', err)
      showToast('Failed to delete item.', 'error')
      return
    }
  }

  const idx = billItems.value.indexOf(item)
  if (idx !== -1) {
    billItems.value.splice(idx, 1)
  }

  // If the last item was removed, reset the bill state
  if (billItems.value.length === 0) {
    clearBill(true)
  }
}

async function changeQty(item, newQty) {
  if (!item) return
  if (newQty < 1) {
    showToast('Minimum quantity is 1. Please use the delete button to remove items.', 'error')
    return
  }

  const delta = newQty - item.qty
  const isExisting = !!(item.itemId || item.transferredItemId)

  if (isExisting && delta < 0) {
    showToast('Quantity of existing items cannot be decreased in a management order.', 'error')
    return
  }

  if (delta > 0) {
    // Increase: Always adds to 'own' share
    item.qty = newQty
    item.ownQty = (item.ownQty || 0) + delta
    item.ownNotPrintedCount = (item.ownNotPrintedCount || 0) + delta
    item.notPrintedCount = (item.ownNotPrintedCount || 0) + (item.transferredNotPrintedCount || 0)
    return
  }

  // Decrease:
  if (isExisting) {
    if (!window.confirm(`Are you sure you want to decrease the quantity of ${item.menu.name}?`)) return
  }

  try {
    const adminId = currentUser.value?.id
    const adminName = currentUser.value?.full_name || currentUser.value?.username || 'System'

    // Priority: Decrease from 'own' shares first
    if ((item.ownQty || 0) > 0) {
      const newOwnQty = item.ownQty - 1
      const newOwnNotPrintedCount = Math.max(0, (item.ownNotPrintedCount || 0) - 1)

      if (item.itemId) {
        await apiFetch(`/orders/${item.itemId}`, {
          method: 'PATCH',
          body: JSON.stringify({ 
            newQty: newOwnQty, 
            newNotPrintedCount: newOwnNotPrintedCount, 
            adminId, 
            adminName 
          })
        })
      }
      item.ownQty = newOwnQty
      item.ownNotPrintedCount = newOwnNotPrintedCount
        if (item.itemId)
      showToast('Quantity decreased from '+item.menu.name, 'success')
    } 
    // If own is exhausted, decrease from transferred share
    else if ((item.transferredQty || 0) > 1) {
      const newTransferredQty = item.transferredQty - 1
      const newTransferredNotPrintedCount = Math.max(0, (item.transferredNotPrintedCount || 0) - 1)

      if (item.transferredItemId) {
        await apiFetch(`/orders/${item.transferredItemId}`, {
          method: 'PATCH',
          body: JSON.stringify({ 
            newQty: newTransferredQty, 
            newNotPrintedCount: newTransferredNotPrintedCount, 
            adminId, 
            adminName 
          })
        })
      }

      item.transferredQty = newTransferredQty
      item.transferredNotPrintedCount = newTransferredNotPrintedCount
      showToast('Quantity decreased from transferred share', 'success')
    }

    // Sync total counts
    item.qty = newQty
    item.notPrintedCount = (item.ownNotPrintedCount || 0) + (item.transferredNotPrintedCount || 0)

  } catch (err) {
    console.error('Failed to update quantity:', err)
    showToast('Failed to update quantity.', 'error')
    // Optionally: fetchOrders() here to resync UI with database if something went wrong
  }
}


function toggleExpansion(item) {
  const targetState = !item.isExpanded
  if (targetState) {
    billItems.value.forEach(i => { i.isExpanded = false })
  }
  item.isExpanded = targetState
}

async function clearBill(skipConfirm = false) {
  // strictly check skipConfirm is not true/truthy event
  if (skipConfirm !== true && billItems.value.length > 0) {
    const isActuallyEditing = currentEditingOrderId.value && currentEditingOrderId.value !== 'null'
    const msg = isActuallyEditing
      ? "Are you sure you want to DELETE this entire order from the database?" 
      : "Are you sure you want to clear the current bill?"
    
    if (!window.confirm(msg)) return

    if (isActuallyEditing) {
      if (!canVoidOrder.value) {
        showToast('You do not have privilege to delete this order.', 'error')
        return
      }
      try {
        const response = await apiFetch(`/orders/group/${currentEditingOrderId.value}`, {
          method: 'DELETE',
          body: JSON.stringify({
            adminId: currentUser.value?.id,
            adminName: currentUser.value?.full_name || currentUser.value?.username || null,
            orderUpdatedAt: getOrderUpdatedAtForGroup(),
          })
        })
        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}))
          throw new Error(errorData.message || 'Failed to delete order.')
        }
        // Remove from local orders list for immediate UI update
        if (Array.isArray(orders.value)) {
          orders.value = orders.value.filter(o => 
            o.id !== currentEditingOrderId.value && 
            o.orderGroupId !== currentEditingOrderId.value &&
            o.createdAt !== currentEditingOrderId.value
          )
        }
        showToast('Order deleted successfully', 'success')
      } catch (err) {
        console.error('Failed to delete order group:', err)
        showToast('Failed to delete order.', 'error')
        return
      }
    }
  }

  const billWasEmpty = billItems.value.length === 0
  billItems.value = []
  
  if (!skipConfirm || billWasEmpty) {
    printFailures.value = []
  }

  tableNumber.value = 'mgt'
  tableError.value = false
  currentEditingOrderId.value = null
  originalWaiterId.value = null
  selectedOrderDate.value = ''
  isDelivery.value = false
  deliveryCompany.value = ''
  deliveryCode.value = ''
  showPaymentModal.value = false
  paymentPhase.value = 'selection'
  selectedPaymentMethod.value = null
  customerPhone.value = ''
  // Keep waiter as the logged-in user
  if (currentUser.value) {
    selectedWaiter.value = currentUser.value.full_name || currentUser.value.username || ''
  }
}

function clearBillAreaOnly() {
  // Clear UI only: no API calls, no logs, no confirmations.
  billItems.value = []
  printFailures.value = []

  tableNumber.value = 'mgt'
  tableError.value = false

  currentEditingOrderId.value = null
  originalWaiterId.value = null
  selectedOrderDate.value = ''

  isDelivery.value = false
  deliveryCompany.value = ''
  deliveryCode.value = ''

  showPaymentModal.value = false
  paymentPhase.value = 'selection'
  selectedPaymentMethod.value = null
  customerPhone.value = ''

  // Keep waiter as the logged-in user
  if (currentUser.value) {
    selectedWaiter.value = currentUser.value.full_name || currentUser.value.username || ''
  }
}

function handleBackOrClear() {
  // Back while editing should only clear the bill area (no DB delete, no log, no confirm)
  if (currentEditingOrderId.value && currentEditingOrderId.value !== 'null') {
    clearBillAreaOnly()
    return
  }
  // Skip confirmation for simply clearing an unsaved bill
  clearBill(true)
}

// getMergedItems is no longer needed as we support individual rows

async function sendOrder() {
  if (billItems.value.length === 0 || isSending.value) return
  isSending.value = true
  try {
  if (isTableMandatory.value === 1 && !tableNumber.value && !isDelivery.value) {
    tableError.value = true
    return
  }
  tableError.value = false
  syncExcludes()
  
  const orderGroupId = currentEditingOrderId.value || `pos-${Date.now()}-${Math.floor(Math.random() * 1000)}`

  if (isDelivery.value && (!deliveryCompany.value || !deliveryCode.value)) {
    showToast('Please select delivery company and enter code.', 'error')
    isSending.value = false
    return
  }

  // TABLE VALIDATION: Check if table number already exists in pending (for this waiter)
  // if (!isDelivery.value && !currentEditingOrderId.value) {
  //   const tableExists = orders.value.some(o => 
  //     o.isPaid !== 1 && 
  //     String(o.table) === String(tableNumber.value) &&
  //     String(o.waiterId) === String(currentUser.value?.id) &&
  //     String(o.id) !== String(currentEditingOrderId.value)
  //   )
  //   if (tableExists) {
  //     showToast('Table number already exists in pending.', 'error')
  //     isSending.value = false
  //     return
  //   }
  // }

  const itemsToSave = []
  billItems.value.forEach(item => {
    const deptId = item.menu.departmentId ?? item.menu.department_id ?? item.menu.deptId ?? item.menu.dept_id;
    const dept = departments.value.find(d => d.id === deptId);
    const printerIP = dept ? dept.printerIP : null;
    const departmentName = dept ? dept.name : 'Unknown Department';
    const howManyCopies = dept ? (Number(dept.how_many_copies ?? dept.howManyCopies ?? 1) || 1) : 1;

    const baseItem = {
      menuId: item.menu.id,
      companyId: companyId.value,
      branchId: branchId.value,
      waiterId: currentEditingOrderId.value ? (originalWaiterId.value || currentUser.value?.id) : (currentUser.value?.id || null),
      tableNumber: tableNumber.value || 'Delivery',
      unitPrice: item.menu.totalPrice,
      price: Number(item.menu.price ?? 0) || 0,
      addition: Number(item.menu.addition ?? 0) || 0,
      vat: Number(item.menu.vat ?? 0) || 0,
      excludeIngredients: item.excludeIngredients,
      note: item.note,
      ingredient_and_amount: buildOrderIngredientAndAmount(item),
      isPaid: 0,
      orderGroupId: orderGroupId,
      deliveryId: isDelivery.value ? deliveryCompany.value : null,
      deliveryCode: isDelivery.value ? deliveryCode.value : null,
      companyName: companyName.value || null,
      printerIP: printerIP,
      departmentName: departmentName,
      departmentId: deptId ?? null,
      howManyCopies: howManyCopies,
      isForStaff: 'Staff'
    }

    if (item.transferredQty > 0) {
      itemsToSave.push({ 
        ...baseItem, 
        itemId: item.transferredItemId || null,
        quantity: item.transferredQty, 
        totalPrice: item.transferredQty * item.menu.totalPrice,
        isAcceptedTransfer: 1,
        not_printed_count: item.transferredNotPrintedCount || 0
      })
    }
    if (item.ownQty > 0) {
      itemsToSave.push({ 
        ...baseItem, 
        itemId: item.itemId || null,
        waiterId: item.itemId ? (originalWaiterId.value || currentUser.value?.id) : (currentUser.value?.id || originalWaiterId.value || null),
        quantity: item.ownQty, 
        totalPrice: item.ownQty * item.menu.totalPrice,
        isAcceptedTransfer: 0,
        not_printed_count: item.ownNotPrintedCount || 0
      })
    }
  })

  try {
    const rawResponse = await apiFetch('/orders', {
      method: 'POST',
      body: JSON.stringify({
        items: itemsToSave,
        orderUpdatedAt: getOrderUpdatedAtForGroup(orderGroupId),
        isOrderUpdate: Boolean(currentEditingOrderId.value),
      }),
    })
    if (!rawResponse.ok) {
      const errorData = await rawResponse.json().catch(() => ({}))
      throw new Error(errorData.message || 'Server error')
    }
    const response = await rawResponse.json().catch(() => ({}))

    if (response && response.printFailures && response.printFailures.length > 0) {
      printFailures.value = response.printFailures
      showToast(`Order saved but printing failed for: ${response.printFailures.join(', ')}`, 'error')
    } else {
      showToast(currentEditingOrderId.value ? 'Order updated successfully' : 'Order sent successfully', 'success')
    }
  } catch (err) { 
    console.error('DB Persistence Failed', err) 
    showToast(err.message || 'Failed to save order.', 'error')
    return
  }

  if (currentEditingOrderId.value) {
    const idx = orders.value.findIndex(o => o.id === currentEditingOrderId.value)
    if (idx !== -1) {
      orders.value[idx].items = billItems.value
      orders.value[idx].table = tableNumber.value
      orders.value[idx].isDelivery = isDelivery.value
      orders.value[idx].deliveryId = isDelivery.value ? deliveryCompany.value : null
      orders.value[idx].deliveryCode = isDelivery.value ? deliveryCode.value : null
    }
  } else {
    const orderId = orderGroupId
    const orderNumber = orders.value.length + 1
    orders.value.push({
      id: orderId,
      orderNumber: orderNumber,
      createdAt: new Date().toISOString(),
      waiterName: selectedWaiter.value,
      waiterId: currentUser.value?.id,
      table: tableNumber.value,
      isPaid: 0,
      isDelivery: isDelivery.value,
      deliveryId: isDelivery.value ? deliveryCompany.value : null,
      deliveryCode: isDelivery.value ? deliveryCode.value : null,
      items: billItems.value,
      orderGroupId: orderGroupId,
      note: billItems.value.map(item => item.note).join(', '), // Assuming note is aggregated or taken from first item
      tableNumber: tableNumber.value,
    })
  }
  
  persistOrders()
  clearBill(true)
  await fetchOrders(false)
  } finally {
    isSending.value = false
  }
}


function handlePaymentSelection(method) {
  selectedPaymentMethod.value = method
  const isCash = method.name?.toLowerCase() === 'cash' || method.name?.toLowerCase() === 'delivery'
  
  if (isCash) {
    markPaid(method)
  } else {
    paymentPhase.value = 'details'
  }
}

async function markPaid(paymentMethod = 'Cash') {
  if (billItems.value.length === 0 || isSending.value) return
  isSending.value = true
  try {
    if (isTableMandatory.value === 1 && !tableNumber.value && !isDelivery.value) {
      tableError.value = true
      return
    }
    tableError.value = false
  syncExcludes()
  
  if (isDelivery.value && (!deliveryCompany.value || !deliveryCode.value)) {
    showToast('Please select delivery company and enter code.', 'error')
    isSending.value = false
    return
  }

  const methodObj = typeof paymentMethod === 'string' ? { name: paymentMethod } : paymentMethod
  const isCash = methodObj.name?.toLowerCase() === 'cash' || methodObj.name?.toLowerCase() === 'delivery'
  const methodName = methodObj.name || 'Cash'
  const paymentMethodToSave = isCash ? methodName : `${methodName}, ${customerPhone.value}`
  
  // Simulation Logic for Phone-based payments
  const isPhonePayment = paymentMethod && !isCash
  
  if (isPhonePayment) {
    isProcessingPayment.value = true
    paymentSimulationStatus.value = 'waiting'
    // Wait for 20 seconds
    await new Promise(resolve => setTimeout(resolve, 20000))
    
    paymentSimulationStatus.value = 'success'
    // Wait for 10 seconds
    await new Promise(resolve => setTimeout(resolve, 10000))
    
    isProcessingPayment.value = false
  }

  const orderGroupId = currentEditingOrderId.value || `pos-${Date.now()}-${Math.floor(Math.random() * 1000)}`

  const itemsToSave = []
  billItems.value.forEach(item => {
    const deptId = item.menu.departmentId ?? item.menu.department_id ?? item.menu.deptId ?? item.menu.dept_id;
    const dept = departments.value.find(d => d.id === deptId);
    const printerIP = dept ? dept.printerIP : null;
    const departmentName = dept ? dept.name : 'Unknown Department';
    const howManyCopies = dept ? (Number(dept.how_many_copies ?? dept.howManyCopies ?? 1) || 1) : 1;

    const baseItem = {
      menuId: item.menu.id,
      companyId: companyId.value,
      branchId: branchId.value,
      waiterId: currentEditingOrderId.value ? (originalWaiterId.value || currentUser.value?.id) : (currentUser.value?.id || null),
      tableNumber: tableNumber.value || 'Delivery',
      unitPrice: item.menu.totalPrice,
      price: Number(item.menu.price ?? 0) || 0,
      addition: Number(item.menu.addition ?? 0) || 0,
      vat: Number(item.menu.vat ?? 0) || 0,
      excludeIngredients: item.excludeIngredients,
      note: item.note,
      ingredient_and_amount: buildOrderIngredientAndAmount(item),
      isPaid: 1,
      orderGroupId: orderGroupId,
      deliveryId: isDelivery.value ? deliveryCompany.value : null,
      deliveryCode: isDelivery.value ? deliveryCode.value : null,
      paymentMethod: paymentMethodToSave,
      printerIP: printerIP,
      departmentName: departmentName,
      departmentId: deptId ?? null,
      howManyCopies: howManyCopies,
      isForStaff: 'Staff'
    }

    if (item.transferredQty > 0) {
      itemsToSave.push({ 
        ...baseItem, 
        itemId: item.transferredItemId || null,
        quantity: item.transferredQty, 
        totalPrice: item.transferredQty * item.menu.totalPrice,
        isAcceptedTransfer: 1,
        not_printed_count: item.transferredNotPrintedCount || 0
      })
    }
    if (item.ownQty > 0) {
      itemsToSave.push({ 
        ...baseItem, 
        itemId: item.itemId || null,
        waiterId: item.itemId ? (originalWaiterId.value || currentUser.value?.id) : (currentUser.value?.id || originalWaiterId.value || null),
        quantity: item.ownQty, 
        totalPrice: item.ownQty * item.menu.totalPrice,
        isAcceptedTransfer: 0,
        not_printed_count: item.ownNotPrintedCount || 0
      })
    }
  })

  try {
    const rawResponse = await apiFetch('/orders', {
      method: 'POST',
      body: JSON.stringify({
        items: itemsToSave,
        orderUpdatedAt: getOrderUpdatedAtForGroup(orderGroupId),
        isOrderUpdate: Boolean(currentEditingOrderId.value),
      }),
    })
    if (!rawResponse.ok) {
      const errorData = await rawResponse.json().catch(() => ({}))
      throw new Error(errorData.message || 'Server error')
    }
    const response = await rawResponse.json().catch(() => ({}))

    if (response && response.printFailures && response.printFailures.length > 0) {
      printFailures.value = response.printFailures
      showToast(`Payment processed but printing failed for: ${response.printFailures.join(', ')}`, 'error')
    } else {
      showToast('Payment processed successfully', 'success')
    }
  } catch (err) { 
    console.error('DB Persistence Failed', err)
    showToast(err.message || 'Failed to process payment.', 'error')
    return
  }

  if (currentEditingOrderId.value) {
    const idx = orders.value.findIndex(o => o.id === currentEditingOrderId.value)
    if (idx !== -1) {
      orders.value[idx].items = billItems.value
      orders.value[idx].isPaid = 1
      orders.value[idx].paymentMethod = paymentMethodToSave
      orders.value[idx].customerPhone = customerPhone.value
      orders.value[idx].isDelivery = isDelivery.value
      orders.value[idx].deliveryCompany = isDelivery.value ? deliveryCompany.value : null
      orders.value[idx].deliveryCode = isDelivery.value ? deliveryCode.value : null
      persistOrders()
    }
  } else if (billItems.value.length > 0) {
    // If we just entered items and clicked paid without sending first
    const waiter = selectedWaiter.value
    const orderId = Date.now()
    const orderNumber = orders.value.length + 1
    const waiterId = currentUser.value?.id
    orders.value.push({
      id: orderId,
      orderNumber: orderNumber,
      createdAt: new Date().toISOString(),
      waiterName: waiter,
      waiterId: waiterId,
      table: tableNumber.value,
      isPaid: 1,
      paymentMethod: paymentMethodToSave,
      customerPhone: customerPhone.value,
      isDelivery: isDelivery.value,
      deliveryId: isDelivery.value ? deliveryCompany.value : null,
      deliveryCode: isDelivery.value ? deliveryCode.value : null,
      items: billItems.value,
    })
    persistOrders()
  }
    clearBill(true)
    await fetchOrders(false)
  } finally {
    isSending.value = false
  }
}

function confirmBill() {
  if (billItems.value.length === 0) return
  if (!canApproveOrder.value) {
    showToast('You do not have privilege to approve orders.', 'error')
    return
  }
  if (isTableMandatory.value === 1 && !tableNumber.value && !isDelivery.value) {
    tableError.value = true
    return
  }

 if( currentEditingOrderId.value!==null && currentEditingOrderId.value!=="null")
  showPaymentModal.value = true
}


const totalPrice = computed(() => {
  return billItems.value.reduce((sum, b) => sum + b.menu.totalPrice * b.qty, 0).toFixed(2)
})

const orderGroups = computed(() => {
  const groupsMap = {}
  if (!Array.isArray(orders.value)) return []

  const uid = currentUser.value?.id || currentUser.value?.sub
  orders.value.filter(o => o && o.isPaid !== 1 && (o.transferStatus !== 0 || String(o.waiterId) === String(uid))).forEach(o => {
    const key = o.id || o.createdAt || Math.random().toString()
    if (!groupsMap[key]) {
      const wName = o.waiterName || o.waiter || ''
      const firstName = wName.split(' ')[0]
      groupsMap[key] = { 
        ...o, 
        waiterName: firstName || 'System',
        totalPriceSum: 0 
      }
    }
    if (Array.isArray(o.items)) {
      const priceSum = o.items.reduce((a, i) => a + (Number(i.qty) || 0) * (Number(i.price) || 0), 0)
      groupsMap[key].totalPriceSum += priceSum
      
      // Check if any item in this group has unprinted quantity
      const hasUnprinted = o.items.some(i => (Number(i.not_printed_count || i.notPrintedCount) || 0) > 0)
      if (hasUnprinted) {
        groupsMap[key].isAnyUnprinted = true
      }
    }
  })
  return Object.values(groupsMap).sort((a,b) => new Date(a.createdAt) - new Date(b.createdAt))
})

const todayOrders = computed(() => {
  const today = new Date().toISOString().split('T')[0]
  return orderGroups.value.filter(o => {
    const orderDate = o.createdAt ? o.createdAt.split('T')[0] : ''
    return orderDate === today || !orderDate
  })
})

const beforeTodayOrders = computed(() => {
  const today = new Date().toISOString().split('T')[0]
  return orderGroups.value.filter(o => {
    const orderDate = o.createdAt ? o.createdAt.split('T')[0] : ''
    return orderDate && orderDate < today
  }).reverse() // Most recent from previous days first
})

// async function handlePageRefresh() {
//   try {
//     showToast('Refreshing page...', 'success')
//     await Promise.all([
//       loadDepartments(),
//       loadMenus(),
//       loadPaymentMethods(),
//       loadDeliveryCompanies(),
//       fetchOrders(false),
//       loadWaiters(),
//       fetchTransferRequests()
//     ])
//     clearBill(true)
//   } catch (err) {
//     console.error('Refresh failed', err)
//     showToast('Failed to refresh page', 'error')
//   }
// }

function viewOrder(orderId) {
  const o = orders.value.find(x => (x.id === orderId) || (x.createdAt === orderId))
  if (!o) return
  currentEditingOrderId.value = o.id
  originalWaiterId.value = o.waiterId || null
  
  const displayedItems = []
  o.items.forEach(i => {
    const isAccepted = Array.isArray(i.transfers) && i.transfers.some(t => t.isAccepted === 1 && t.receiverId === currentUser.value?.id)
    const menuObj = menus.value.find(m => m.id === i.menuId)
    
    // Merge identical database items for display
    const existing = displayedItems.find(mi => 
      mi.menu.id === i.menuId && 
      (mi.excludeIngredients || '') === (i.excludeIngredients || '') && 
      (mi.note || '') === (i.note || '')
    )
    
    if (existing) {
      const qtyToAdd = i.quantity || i.qty
      const npToAdd = (i.not_printed_count || i.notPrintedCount || 0)
      existing.qty += qtyToAdd
      if (isAccepted) {
        existing.transferredQty += qtyToAdd
        existing.transferredNotPrintedCount += npToAdd
        existing.transferredItemId = i.id || i.itemId
      } else {
        existing.ownQty += qtyToAdd
        existing.ownNotPrintedCount += npToAdd
        existing.itemId = i.id || i.itemId
      }
      existing.notPrintedCount += npToAdd
    } else {
      const recipeIngs = menuObj?.recipes?.recipe_ingredients || []
      const excludedList = (i.excludeIngredients || '').split(',').map(s => s.trim()).filter(Boolean)
      const activeIngs = recipeIngs.filter(ri => ri.is_active === 1).map(ri => {
        const name = ri.items?.itemName || ri.item?.name || ri.products?.name || ri.product?.name || 'Unknown'
        return { id: ri.id, name, checked: !excludedList.includes(name) }
      })

      displayedItems.push({
        localId: `load-${i.id || i.itemId || Math.random()}`,
        itemId: isAccepted ? undefined : (i.id || i.itemId),
        transferredItemId: isAccepted ? (i.id || i.itemId) : undefined,
        menu: { ...(menuObj || i.menu), id: i.menuId, totalPrice: i.price || i.unitPrice }, 
        qty: i.quantity || i.qty,
        transferredQty: isAccepted ? (i.quantity || i.qty) : 0,
        ownQty: isAccepted ? 0 : (i.quantity || i.qty),
        isAcceptedTransfer: isAccepted,
        originalQty: i.quantity || i.qty,
        orderId: o.id,
        orderNumber: o.orderNumber,
        excludeIngredients: i.excludeIngredients || '',
        ingredients: activeIngs,
        isExpanded: false,
        selected: false,
        note: i.note || '',
        transferredNotPrintedCount: isAccepted ? (i.not_printed_count || i.notPrintedCount || 0) : 0,
        ownNotPrintedCount: isAccepted ? 0 : (i.not_printed_count || i.notPrintedCount || 0),
        notPrintedCount: i.not_printed_count || i.notPrintedCount || 0,
        preparation_status: i.preparation_status
      })
    }
  })
  billItems.value = displayedItems
  
  tableNumber.value = 'mgt'
  selectedWaiter.value = o.waiterName || o.waiter || ''
  isDelivery.value = !!o.isDelivery || o.table === 'Delivery'
  deliveryCompany.value = o.deliveryId || o.deliveryCompany || ''
  deliveryCode.value = o.deliveryCode || ''
  if (o.createdAt) {
    const datePart = o.createdAt.split('T')[0] // YYYY-MM-DD
    const timePart = new Date(o.createdAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
    selectedOrderDate.value = `${datePart} ${timePart}`
  } else {
    selectedOrderDate.value = ''
  }
  
  viewMode.value = 'bill'
  nextTick(() => {
    scrollToBottom()
  })
}
</script>

<style scoped>
input[type=number].no-spinner::-webkit-outer-spin-button,
input[type=number].no-spinner::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number].no-spinner {
  appearance: textfield;
  -moz-appearance: textfield;
}

/* TABLE STYLE (same as first component) */

table {
  font-family: 'Segoe UI', sans-serif;
  font-size: 0.75rem;
  color: #1e293b;
}

th,
td {
  padding: 8px 10px;
  text-align: left;
  border-bottom: 1px solid #e2e8f0;
  white-space: nowrap;
}

th {
  background: #f1f5f9;
  cursor: default;
  font-weight: 600;
  position: sticky;
  top: 0;
  z-index: 20;
}

.recipe-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 15px;
}



.custom-scrollbar::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
.custom-scrollbar::-webkit-scrollbar-track {
  background: #f1f5f9;
}
.custom-scrollbar::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}
.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* Modal Transitions */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* Chrome, Safari, Edge, Opera */
.no-spinner::-webkit-outer-spin-button,
.no-spinner::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
.no-spinner {
  appearance: textfield;
  -moz-appearance: textfield;
}
/* Toast Transitions */
.toast-enter-active,
.toast-leave-active {
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.toast-enter-from {
  opacity: 0;
  transform: translateX(100px);
}

.toast-leave-to {
  opacity: 0;
  transform: scale(0.9);
}

.spinner {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: #fff;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}
</style>
